import { createSlice } from "@reduxjs/toolkit";
import { getAiCampaignMembersAPI } from "../../services/getAiCampaignMembers";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getAiCampaignMembersSlice = createSlice({
  name: "getAiCampaignMembers",
  initialState: data,
  reducers: {
    getAiCampaignMembersInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getAiCampaignMembersInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
      state.error = "";
    },
    getAiCampaignMembersInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getAiCampaignMembersInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getAiCampaignMembersHandler = (payload) => async (dispatch) => {
  try {
    dispatch(getAiCampaignMembersAction.getAiCampaignMembersInfo());
    const response = await getAiCampaignMembersAPI(payload);
    dispatch(getAiCampaignMembersAction.getAiCampaignMembersInfoSuccess(response));
  } catch (e) {
    dispatch(
      getAiCampaignMembersAction.getAiCampaignMembersInfoFailure(
        e?.response?.data?.message || e?.message || e,
      ),
    );
  }
};

export default getAiCampaignMembersSlice.reducer;
export const getAiCampaignMembersAction = getAiCampaignMembersSlice.actions;
